module.exports = __webpack_public_path__ + "media/images/hide-icon-1c9d334a122a48ec55bf3d3ace856845.png";